import { type Breakpoint } from '@divi/types';

import { getEnabledBreakpoints } from '../get-enabled-breakpoints';
import { getWindowWidth } from '../get-window-width';

/**
 * Get the current window mode.
 *
 * Get the current window mode by checking the window width.
 *
 * @since ??
 *
 * @returns {string} The current window mode ('desktop', 'tablet', 'phone').
 */
const getCurrentWindowMode = (): Breakpoint.Name => {
  const windowWidth = getWindowWidth();

  const enabledBreakpoints = getEnabledBreakpoints();

  const baseBreakpoint: Breakpoint.Name =
    enabledBreakpoints.find(breakpoint => breakpoint?.baseDevice)?.name ?? 'desktop';

  let breakpointName: Breakpoint.Name;
  let currentMaxWidthValue: number = null;
  let currentMinWidthValue: number = null;

  // Loop through the breakpoints to find matching breakpoint against window width.
  enabledBreakpoints.forEach(breakpoint => {
    if (breakpoint?.baseDevice) {
      return;
    }

    const maxWidthValue = breakpoint?.maxWidth?.value;
    const minWidthValue = breakpoint?.minWidth?.value;

    if (
      maxWidthValue &&
      minWidthValue &&
      parseInt(maxWidthValue) >= windowWidth &&
      parseInt(minWidthValue) <= windowWidth
    ) {
      breakpointName = breakpoint?.name;
    }

    if (maxWidthValue && !minWidthValue) {
      const maxWidthValueInt = parseInt(maxWidthValue);

      if (
        maxWidthValueInt >= windowWidth &&
        // The first time we find a breakpoint with matching max-width media query.
        (null === currentMaxWidthValue ||
          // OR, there's another matching max-width media query that's smaller than the current one.
          maxWidthValueInt < currentMaxWidthValue)
      ) {
        breakpointName = breakpoint?.name;
        currentMaxWidthValue = maxWidthValueInt;
      }
    }

    if (!maxWidthValue && minWidthValue) {
      const minWidthValueInt = parseInt(minWidthValue);

      // Do secondary check.
      if (
        // breakpoint's minWidth media query is smaller than window width.
        minWidthValueInt <= windowWidth &&
        // The first time we find a breakpoint with matching min-width media query.
        (null === currentMinWidthValue ||
          // OR, there's another matching min-width media query that's larger than the current one.
          minWidthValueInt > currentMinWidthValue)
      ) {
        breakpointName = breakpoint?.name;
        currentMinWidthValue = minWidthValueInt;
      }
    }
  });

  return breakpointName ?? baseBreakpoint;
};

export { getCurrentWindowMode };
